// SalesSection.js
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import device from '../utils/device';
import PaymentBox from './PaymentBox';
import PaymentStripeBox from './PaymentStripeBox';
import Quotes from './Quotes';

const Container = styled.section`
  @media ${device.desktop} {
    margin-top: 0rem;
  }
`;

const PaymentRow = styled.div`
  margin: 1.6rem;

  @media ${device.desktop} {
    display: flex;
    margin: 0 10vw;
    padding: 4rem 0;
    justify-content: space-evenly;
  }
`;

const SalesSection = (props) => {

  return (
    <Container>
      <PaymentRow>
      <PaymentBox
      title="Payment upfront"
      subTitle="One single payment:"
      discount="50"
      benefit="Lifetime access"
      wasUsd={497 * 2}
      priceUsd={497}
      priceEuro={497}
      priceGbp={429}
      codeUsd="4890517"
      codeEuro="4890529"
      codeGbp="4890528"
      best
    />
    <PaymentBox
      title="Installments"
      subTitle="3 payments of"
      discount="40"
      benefit="Lifetime access after 3 months"
      priceUsd={190}
      priceEuro={190}
      priceGbp={170}
      codeUsd="4890514"
      codeEuro="4890532"
      codeGbp="4890531"
    />
    {props.showInstallmentBox && (
      <PaymentStripeBox
      title="Payment upfront"
      subTitle="One single payment:"
      discount="50"
      benefit="Lifetime access"
      wasUsd={497 * 2}
      priceUsd={497}
      priceEuro={497}
      priceGbp={429}
      codeUsd="price_1OXbklAunGE27Q7CUPAEiemM"
      codeEuro="price_1OXblOAunGE27Q7CJ6oUm9sL"
      codeGbp="price_1OXbl1AunGE27Q7C7XljJUbw"
      paymentType="upfront"
      />
    )}
    {props.showInstallmentBox && (
      <PaymentStripeBox
        title="Installments"
        subTitle="3 payments of"
        discount="40"
        benefit="Lifetime access after 3 months"
        priceUsd={190}
        priceEuro={190}
        priceGbp={170}
        codeUsd="price_1OZQ5cAunGE27Q7CyvFJSTwb"
        codeEuro="price_1OYklRAunGE27Q7CwOujXVpt"
        codeGbp="price_1OZQ52AunGE27Q7CUB0x9oYc"
        paymentType="installment"
      />
    )}
      </PaymentRow>
      <Quotes />
      <PaymentRow>
      </PaymentRow>
    </Container>
  );
};

export default SalesSection;
